'use client';

import { c as _c } from "react/compiler-runtime";
import { type ImageProps } from 'next/image';
import { useState } from 'react';
import { Image } from '@/app/components/media/image';
import { useOverlayMountControl } from '@/app/components/overlays/hooks/useOverlayMountControl';
import { GalleryZoomModal } from '@/app/components/overlays/modal/gallery-zoom-modal';
import { OVERLAY_KEYS } from '@/app/constants/overlayKeys';
import { cn } from '@/app/utils/cn';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
const MAX_IMAGES = 6;
const DETAILS_GALLERY_INSTANCE_ID = 'details-gallery';
export interface DetailsGalleryProps {
  images?: Pick<ImageProps, 'src' | 'alt' | 'width' | 'height'>[];
  title?: string;
  testId?: string;
}
export const DetailsGallery = t0 => {
  const $ = _c(20);
  const {
    images: t1,
    title: t2,
    testId: t3
  } = t0;
  const images = t1 === undefined ? [] : t1;
  const title = t2 === undefined ? "\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21" : t2;
  const testId = t3 === undefined ? "details-gallery" : t3;
  const [initialIndex, setInitialIndex] = useState(0);
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      overlayKey: OVERLAY_KEYS.MODAL_GALLERY,
      instanceId: DETAILS_GALLERY_INSTANCE_ID
    };
    $[0] = t4;
  } else {
    t4 = $[0];
  }
  const {
    shouldRender,
    open
  } = useOverlayMountControl(t4);
  let t5;
  if ($[1] !== open) {
    t5 = index => {
      setInitialIndex(index);
      open();
    };
    $[1] = open;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  const openAtIndex = t5;
  if (!images.length) {
    return null;
  }
  let t6;
  if ($[3] !== testId || $[4] !== title) {
    t6 = !!title && <h2 className="text-sub-h1 font-noto-bold mb-4 lg:mb-6" {...createDataAttributes({
      test: `${testId}-title`
    })}>{title}</h2>;
    $[3] = testId;
    $[4] = title;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const t7 = "grid grid-cols-2 gap-2 sm:grid-cols-3";
  const t8 = `${testId}-thumb-wrapper`;
  let t9;
  if ($[6] !== t8) {
    t9 = createDataAttributes({
      test: t8
    });
    $[6] = t8;
    $[7] = t9;
  } else {
    t9 = $[7];
  }
  const t10 = images.slice(0, MAX_IMAGES).map((image, index_0) => {
    const isOverlayThumbnail = images.length > MAX_IMAGES && index_0 === MAX_IMAGES - 1;
    return <button key={`${image.src}`} type="button" className="group aspect-1-1 relative cursor-pointer overflow-hidden rounded-md" onClick={() => openAtIndex(index_0)} {...createDataAttributes({
      test: `${testId}-thumb-${index_0}`
    })}><Image src={`${image.src}`} alt={`${image.alt}`} width={220} height={220} layout="ratio" aspectRatio="aspect-1-1" hoverEffect="zoom" isGroupHover={true} className={cn("aspect-1-1 absolute inset-0 rounded-md", {
        "after:transition-form after:absolute after:inset-0 after:rounded-md after:bg-black/30 after:duration-300 group-hover:after:bg-black/50": isOverlayThumbnail
      })} sizes="(min-width: 1024px) 220px, 50vw" />{!!isOverlayThumbnail && <span className="text-sub-h3 center-x center-y font-noto-bold absolute text-white">+{images.length - MAX_IMAGES}</span>}</button>;
  });
  let t11;
  if ($[8] !== t10 || $[9] !== t9) {
    t11 = <div className={t7} {...t9}>{t10}</div>;
    $[8] = t10;
    $[9] = t9;
    $[10] = t11;
  } else {
    t11 = $[10];
  }
  let t12;
  if ($[11] !== images || $[12] !== initialIndex || $[13] !== shouldRender || $[14] !== testId) {
    t12 = !!shouldRender && <GalleryZoomModal images={images} initialIndex={initialIndex} overlayKey={OVERLAY_KEYS.MODAL_GALLERY} instanceId={DETAILS_GALLERY_INSTANCE_ID} testId={`${testId}-zoom-modal`} />;
    $[11] = images;
    $[12] = initialIndex;
    $[13] = shouldRender;
    $[14] = testId;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] !== t11 || $[17] !== t12 || $[18] !== t6) {
    t13 = <>{t6}{t11}{t12}</>;
    $[16] = t11;
    $[17] = t12;
    $[18] = t6;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  return t13;
};